import { useQuery } from "@tanstack/react-query";
import { getUserProfileRequest } from "../requests/user/profile";
import { useAuth } from "../../contexts/auth/Context";
import { USER_PROFILE_QUERY_KEY } from "../../query/keys";

const DEFAULT_ERROR = "Error al obtener el perfil";

export const useUserProfile = () => {
  const { token } = useAuth();

  const {
    data: userProfile = null,
    isLoading,
    error: queryError,
    refetch: refreshUserProfile,
  } = useQuery({
    queryKey: USER_PROFILE_QUERY_KEY,
    queryFn: () => getUserProfileRequest(token!),
    enabled: !!token,
  });

  const error = queryError
    ? queryError instanceof Error
      ? queryError.message
      : DEFAULT_ERROR
    : null;

  return {
    userProfile,
    isLoading,
    error,
    refreshUserProfile,
  };
};
